// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__shQBs","occupiedTable":"styles_occupiedTable__qFuFz"};